<template>
  <div>
    <div class="w-full flex flex-wrap justify-center bg-blue items-center relative z-50" style="height: 70px">
      <router-link :to="'/' + Language + '/'">
        <img width="176" src="../../assets/img/plexytrade-logo-white.svg" />
      </router-link>
      <div class="absolute ltr:right-4 rtl:left-4 top-4">
        <language-popover></language-popover>
      </div>
    </div>
    <div class="flex justify-center items-center h-calc1 relative z-0 m-2 md:m-0">
      <div class="bg-white rounded-lg shadow-ts1 px-5 md:px-7 py-12 w-full md:w-[36rem] max-w-[580px]">
        <h1 class="text-blue font-display font-bold text-3xl md:text-[2.5rem] pb-10 text-center">{{ $t('reset_your_old_password').tTitle() }}</h1>
        <p class="text-gray-900 text-base leading-7 w-full md:w-[24.5rem] m-auto text-center pb-10">{{ $t('reset_password_desc') }}</p>
        <form v-on:submit.prevent="sendResetPasswordLink">
          <div class="mb-10">
            <label for="email" class="text-base text-gray-900">{{ $t('email').tTitle() }}</label>
            <input
              type="email"
              name="email"
              v-model="data.body.email"
              class="rounded-md bg-gray-100 ltr:pl-5 rtl:pr-5 w-full h-12 mt-2 text-base text-gray-900 font-semibold focus:outline-none focus:ring-0 border border-gray-100 border-solid focus:border-gray-900 placeholder:text-gray-900 placeholder:text-opacity-20"
              placeholder="email@example.org"
            />
          </div>
          <button type="submit" class="bg-blue text-white text-center text-base font-bold h-[3.1rem] w-[12.3rem] rounded-md m-auto table appearance-none mb-10">
            {{ $t('submit').tTitle() }}
          </button>
          <p class="text-gray-900 w-full text-center text-[11px] md:text-xs border-t border-solid border-[#DEDFE2] pt-10">
            {{ $t('risk_sentence') }}<a class="font-bold ltr:pl-1 rtl:pr-1" :href="privacyPolicyLink" target="_blank">{{ $t('privacy_policy').tTitle() }}</a>
          </p>
        </form>
      </div>
    </div>
    <div class="max-w-[1399px] relative m-auto">
      <footer-collapsible></footer-collapsible>
    </div>
    <logo-loader v-if="showLoader"></logo-loader>
  </div>
</template>

<script>
import { service } from '../../main.js'
import config from '../../config'
import { mapGetters } from 'vuex'
import LogoLoader from '../../components/LogoLoader'
import FooterCollapsible from '../../components/FooterCollapsible.vue'
import LanguagePopover from '@/components/Language.vue'
import links from '../../config/links'

export default {
  components: {
    LogoLoader,
    FooterCollapsible,
    LanguagePopover,
  },
  data() {
    return {
      showLoader: false,
      data: {
        body: {
          email: null,
        },
      },
      error: null,
    }
  },
  computed: {
    websiteURL() {
      return config.URL.website
    },
    privacyPolicyLink() {
      return links.getLink('privacyPolicy', 'en')
    },
    ...mapGetters({
      Language: 'language/code',
    }),
  },
  mounted() {
    this.$bus.$emit('ChangeHeadings', this.$t('reset_password').tCapitalizeFirstLetter(), null)
    this.addMeta('description', this.$t('transfer_reset_description'))
    this.addMeta('canonical', config.URL.cp + this.$route.path)
    this.addMeta('alternate', this.$route.meta.identifierPath)
    this.addMeta('ogtitle', this.$t('reset_password').tCapitalizeFirstLetter())
    this.data.body.email = ''

    if (this.$auth.check()) {
      this.$router.push('/' + (this.Language || 'en') + '/' + config.defaultURL)
    }
  },
  methods: {
    sendResetPasswordLink() {
      if (this.data.body.email === '') {
        document.getElementById('email').focus()
        return
      }
      this.showLoader = true
      service
        .post('/users/forgot-password', {
          email: this.data.body.email,
        })
        .then(response => {
          this.showLoader = false
          if (response.data.success) {
            this.$toasted.success(this.$t('forgot_password_submit_success_message', { email: this.data.body.email }).tTitle())
          } else {
            if (typeof response.data.messageID !== 'undefined') {
              this.$toasted.error(this.$t(response.data.messageID).tTitle())
            }
          }
          this.data.body.email = ''
        })
        .catch(() => {
          this.showLoader = false
          this.$toasted.error(this.$t('internal_error'))
        })
    },
  },
  filters: {
    json: function (value) {
      return value
    },
  },
}
</script>
